import { createAsyncThunk } from '@reduxjs/toolkit';

import { UPLOADS_SLICE_NAME } from './uploadsSliceName';
import { uploadFileWithProgress } from './xhrUpload';
import { UploadFileThunkArg } from './uploadFileThunkArg';
import { UploadFileResult } from './uploadFileResult';

export const uploadFile = createAsyncThunk<UploadFileResult, UploadFileThunkArg, { rejectValue: string }>(
  `${UPLOADS_SLICE_NAME}/uploadFile`,
  async ({ id, file, document, variables, filePath }, { dispatch, rejectWithValue }) => {
    try {
      return await uploadFileWithProgress({ file, document, variables, filePath }, (progress) => {
        dispatch({ type: `${UPLOADS_SLICE_NAME}/setProgress`, payload: { id, progress } });
      });
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  }
);
